import { render, staticRenderFns } from "./DocumentRead.vue?vue&type=template&id=21a6d30b"
import script from "./DocumentRead.vue?vue&type=script&lang=js"
export * from "./DocumentRead.vue?vue&type=script&lang=js"
import style0 from "./DocumentRead.vue?vue&type=style&index=0&id=21a6d30b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports